import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "insuranceType",
    "payerIdContainer",
    "numPayers",
    "payerId",
    "button",
    "brokerContainer",
    "brokerCheckbox"
  ]

  connect() {
    this.refresh();
  }

  refresh() {
    // The user must answer the first question about the type of insurance they have
    const insuranceType = this.insuranceTypeTarget.value;
    if (insuranceType == "") {
      this.payerIdContainerTarget.classList.add("hidden");
      this.buttonTarget.disabled = true;
      return;
    }

    // If they don't have insurance, they can go on.
    if (insuranceType == "no") {
      this.payerIdContainerTarget.classList.add("hidden");
      this.buttonTarget.disabled = false;
      return;
    }

    // if they are on exchange, we show the broker field
    // if (insuranceType === "exchange") {
    //   this.brokerCheckboxTarget.checked = true;
    //   this.brokerContainerTarget.classList.remove("hidden");
    // }

    // If we don't have any payers to pick from, they can go on.
    if (this.numPayersTarget.value == 0) {
      this.payerIdContainerTarget.classList.add("hidden");
      this.buttonTarget.disabled = false;
      return;
    }

    // If we decided not to have people pick a specific payer, they can go on.
    if (this.payerIdContainerTarget.getAttribute("data-pick-specific-payer") == "false") {
      this.payerIdContainerTarget.classList.add("hidden");
      this.buttonTarget.disabled = false;
      return;
    }

    // Reveal the insurer picker.
    this.payerIdContainerTarget.classList.remove("hidden");
    const payerId = this.payerIdTarget.value;

    // If they have some sort of insurance, they need to specify who's the insurer.
    if (payerId == "") {
      this.buttonTarget.disabled = true;
      return;
    }

    this.buttonTarget.disabled = false;
  }
}